module.exports = __webpack_public_path__ + "static/media/ic-connect.01c3b5de.svg";